/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary List supplier functions
 */

export const listSupplierFunctionsQueryPerPageMax = 100;

export const listSupplierFunctionsQueryStateDefault = `ACTIVE`;
export const listSupplierFunctionsQuerySortKeyDefault = `supplierFunctionId`;

export const ListSupplierFunctionsQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).describe("Page number (1-indexed)"),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listSupplierFunctionsQueryPerPageMax)
    .describe("Number of items per page"),
  q: zod.coerce
    .string()
    .optional()
    .describe("Case-insensitive substring search across Supplier Function code or name"),
  state: zod
    .enum(["ACTIVE", "DELETED", "ALL"])
    .default(listSupplierFunctionsQueryStateDefault)
    .describe("Supplier Function state filter"),
  sortKey: zod
    .enum(["supplierFunctionId", "code", "name"])
    .default(listSupplierFunctionsQuerySortKeyDefault)
    .describe("Supplier Function sort key"),
  sortDir: zod.enum(["asc", "desc"]).optional().describe("Sort direction"),
});

export const listSupplierFunctionsResponseMetaTotalMin = 0;

export const ListSupplierFunctionsResponse = zod.object({
  items: zod.array(
    zod.object({
      supplierFunctionId: zod.uuid().describe("Supplier Function identity."),
      state: zod.enum(["ACTIVE", "DELETED"]),
      createdAt: zod.iso.datetime({offset: true}),
      updatedAt: zod.iso.datetime({offset: true}),
      deletedAt: zod.iso.datetime({offset: true}).nullable(),
      code: zod.string(),
      name: zod.string(),
      description: zod.string(),
    }),
  ),
  meta: zod
    .object({
      total: zod
        .int()
        .min(listSupplierFunctionsResponseMetaTotalMin)
        .describe("Total matching items."),
      page: zod.int().min(1).describe("Current 1-indexed page."),
      perPage: zod.int().min(1).describe("Requested items per page."),
    })
    .describe("Metadata for a paginated collection."),
});

/**
 * @summary Create supplier function
 */
export const CreateSupplierFunctionBody = zod.object({
  code: zod.string(),
  name: zod.string(),
  description: zod.string(),
});

export const CreateSupplierFunctionResponse = zod.uuid().describe("Supplier Function identity.");

/**
 * @summary Get supplier function
 */
export const getSupplierFunctionQueryIncludeDeletedDefault = false;

export const GetSupplierFunctionQueryParams = zod.object({
  includeDeleted: zod.boolean().default(getSupplierFunctionQueryIncludeDeletedDefault),
});

export const GetSupplierFunctionResponse = zod.object({
  supplierFunctionId: zod.uuid().describe("Supplier Function identity."),
  state: zod.enum(["ACTIVE", "DELETED"]),
  createdAt: zod.iso.datetime({offset: true}),
  updatedAt: zod.iso.datetime({offset: true}),
  deletedAt: zod.iso.datetime({offset: true}).nullable(),
  code: zod.string(),
  name: zod.string(),
  description: zod.string(),
});

/**
 * @summary Update supplier function
 */
export const UpdateSupplierFunctionBody = zod.object({
  code: zod.string(),
  name: zod.string(),
  description: zod.string(),
});

export const UpdateSupplierFunctionResponse = zod.void();

/**
 * @summary Delete supplier function
 */
export const DeleteSupplierFunctionResponse = zod.void();

/**
 * @summary Restore supplier function
 */
export const RestoreSupplierFunctionResponse = zod.void();
